import { render, staticRenderFns } from "./CompanyUsers.vue?vue&type=template&id=2c4e4ead&scoped=true"
import script from "./CompanyUsers.vue?vue&type=script&lang=js"
export * from "./CompanyUsers.vue?vue&type=script&lang=js"
import style0 from "./CompanyUsers.vue?vue&type=style&index=0&id=2c4e4ead&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4e4ead",
  null
  
)

export default component.exports